import { useCallback, useEffect, useState } from 'react';

export const useFullscreen = () => {
  const [active, setActive] = useState(!!document.fullscreenElement);

  useEffect(() => {
    const fullscreenCallback = (e: Event) => {
      setActive(!!document.fullscreenElement);
    };
    document.addEventListener('fullscreenchange', fullscreenCallback);

    return () => {
      document.removeEventListener('fullscreenchange', fullscreenCallback);
    };
  }, []);

  const request = useCallback(
    (element: Element, options?: FullscreenOptions) => element.requestFullscreen(options),
    []
  );
  const exit = useCallback(() => document.exitFullscreen(), []);

  return {
    supported: document.fullscreenEnabled,
    container: document.fullscreenElement,
    active,
    request,
    exit,
  };
};
